import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className"];
import React, { forwardRef } from 'react';
import { bool, elementType, oneOf, node, string } from 'prop-types';
import classNames from 'classnames';
import { InputAdornment as MuiInputAdornment } from '@material-ui/core';
const InputAdornment = /*#__PURE__*/forwardRef(function InputAdornment(props, ref) {
  const {
      className
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(MuiInputAdornment, Object.assign({}, otherProps, {
    className: classNames('pds-input-adornment', className),
    ref: ref,
    disableTypography: true
  }));
});
InputAdornment.propTypes = {
  /**
   * The content of the component, usually a Button or string.
   */
  children: node.isRequired,
  /**
   * The CSS class name to apply to the root of the component.
   */
  className: string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */
  disablePointerEvents: bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: oneOf(['start', 'end'])
};
InputAdornment.defaultProps = {
  component: 'div',
  disablePointerEvents: true
};
export default InputAdornment;